import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6db8affa")

_pushScopeId("data-v-6db8affa")
const _hoisted_1 = { class: "moment-box amplily-player" }
const _hoisted_2 = { class: "content-holder" }
const _hoisted_3 = { class: "timeline-hldr" }
const _hoisted_4 = {
  class: "moments",
  ref: "trackElm"
}
const _hoisted_5 = { class: "track" }
const _hoisted_6 = {
  key: 0,
  class: "relative rounded-corners"
}
const _hoisted_7 = {
  key: 1,
  class: "relative"
}
const _hoisted_8 = { class: "icon-holder" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "title",
            innerHTML: _ctx.title_txt
          }, null, 8, ["innerHTML"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "trailer-timeline",
          style: _ctx.css
        }, null, 4),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.momentDataArr, (m, i) => {
          return (_openBlock(), _createBlock("svg", {
            key: i,
            style: { left: `${m.start_per}% !important` },
            class: "pt start",
            width: "4",
            height: "4",
            viewBox: "0 0 4 4",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createVNode("circle", {
              cx: "2",
              cy: "2",
              r: "2",
              class: {
              'fill-themecolor-5': !m.isResource,
              'fill-tranparent': m.isResource,
              'fill-themecolor': _ctx.activeMoments.includes(m.id) && !m.isResource
            }
            }, null, 2)
          ], 4))
        }), 128)),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.momentDataArr, (m, i) => {
          return (_openBlock(), _createBlock("svg", {
            key: i,
            style: { left: `${m.end_per}% !important` },
            class: "pt end",
            width: "4",
            height: "4",
            viewBox: "0 0 4 4",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createVNode("circle", {
              cx: "2",
              cy: "2",
              r: "2",
              class: {
              'fill-themecolor-5': !m.isResource,
              'fill-tranparent': m.isResource,
              'fill-themecolor': _ctx.activeMoments.includes(m.id) && !m.isResource
            }
            }, null, 2)
          ], 4))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.momentDataArr, (m, i) => {
            return (_openBlock(), _createBlock("div", {
              class: {
              'moment-holdr': true,
              animate: true,
              slow: !_ctx.isVisited
            },
              key: i,
              style: {
              transform: `translateX(${m.transform}px) !important`,
              opacity: `${m.opacity} !important`
            },
              ref: 
              el => {
                if (el) _ctx.momentElms[i] = el
              }
            
            }, [
              (!m.isResource)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("img", {
                      class: "image rounded-corners",
                      src: m.poster_url,
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("div", {
                      class: "duration",
                      innerHTML: _ctx.formatDate(m.duration)
                    }, null, 8, ["innerHTML"])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", {
                        class: "icon icon-color",
                        innerHTML: _ctx.getResourceSvg(m.resourceType)
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode("div", {
                      class: "duration",
                      innerHTML: _ctx.getResourceLabel(m.resourceType.toUpperCase())
                    }, null, 8, ["innerHTML"])
                  ])),
              _createVNode("span", {
                class: "title truncate-overflow",
                innerHTML: _ctx.translateTrailerBox(m).title
              }, null, 8, ["innerHTML"])
            ], 6))
          }), 128))
        ])
      ], 512)
    ])
  ]))
})